import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { DragulaService } from "ng2-dragula";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var alertify: any;

@Component({
  selector: "app-share-product",
  templateUrl: "./share-product.component.html",
  styleUrls: ["./share-product.component.css"],
})
export class ShareProductComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private http: HttpService,
    private dragulaService: DragulaService
  ) {
    dragulaService.setOptions("share-product-bag", {
      copy: false,
    });
    dragulaService.drop.subscribe((value) => {
      //console.log('drop: ${value[0]}');
      this.onDrop(value.slice(1));
    });
  }

  ngOnInit() {
    this.getPath();
  }

  private data: any = [];
  private imagePath: string = "";

  private onDrop(args) {
    let [e, el] = args;
    // do something
    this.getList();
  }

  private postData: any = [];

  //推送
  public isLoading: boolean = false;

  public page = {
    pageNumber: 1,
    pageSize: 10,
    totalPages: 0,
    active: "",
    searchValue: "",
  };

  public searchValue = { active: "", searchValue: "" };

  //获取排序列表
  private getList() {
    this.postData = [];
    for (let i = 1; i < this.data.length + 1; i++) {
      this.postData.push({ id: this.data[i - 1].id, rank: i });
    }
  }

  private sort(): void {
    this.http
      .postData(API.shareProduct + "/sort", this.postData)
      .then((res) => {
        let data = res;
        if (data.status.code == 0 || data.status.code == "0") {
          alertify.success(data.status.message);
        } else {
          alertify.error(data.status.message);
        }
      });
  }

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  private getData(isSearch: boolean = false) {
    let data = { ...this.page };
    data.pageNumber = data.pageNumber - 1;
    // delete data.totalPages;
    if (isSearch) {
      data = { ...data, ...this.searchValue };
    }
    this.http.getData(API.shareProductPage, data).then((res) => {
      this.data = res.data;
      this.page.pageNumber = res.data.number + 1;
      this.page.pageSize = res.data.size;
      this.page.totalPages = res.data.totalPages;
    });
  }

  private editQues(id: number): void {
    this.router.navigate(["index/shareproduct", id]);
  }

  private deleteQues(id: number): void {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.deleteData(API.shareProduct + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () { }
    );
  }

  public ngOnDestroy() {
    this.dragulaService.destroy("share-product-bag");
  }

  public searchData() {
    this.getData(true);
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/share-product/share-product.component.ts